import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ViewChild, AfterViewInit, Component, OnInit } from '@angular/core';
import { PlmService } from 'src/app/shared/services/plm.service';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-progress-report-list',
  templateUrl: './progress-report-list.component.html',
  styleUrl: './progress-report-list.component.css'
})
export class ProgressReportListComponent implements OnInit, AfterViewInit {
  columnsToDisplay = ['reportDate', 'organization', 'workDescription', 'progressPercentage', 'qualityPassed', 'inspectionDone', 'photo', 'actions'];
  dataSource = new MatTableDataSource<any>([]);
  media: any[] = [];
  projects: any[] = [];
  locations: any[] = [];
  workItems: any[] = [];
  projectId: number | null = null;
  form: any = { work_location_id: '', pavement_work_item_id: '', qty: '', remarks: '', weather: '' };
  mediaForm: any = { work_location_id: '', caption: '', latitude: '', longitude: '', file_url: '' };

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private plm: PlmService, private api: ApiService, private toastr: ToastrMsgService) {}

  ngOnInit(): void {
    this.api.getProjectCommonAll({ page: 1, limit: 200 }).subscribe({
      next: (res: any) => (this.projects = res?.data || []),
    });
    this.reload();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  onProject(): void {
    const q = { project_id: this.projectId || undefined };
    this.plm.listWorkLocations(q).subscribe({ next: (r: any) => (this.locations = r.data || []) });
    this.plm.listPavementWork(q).subscribe({ next: (r: any) => (this.workItems = r.data || []) });
    this.reload();
  }

  reload(): void {
    const q = { project_id: this.projectId || undefined };
    this.plm.listDailyProgress(q).subscribe({
      next: (r: any) => {
        const rows = (r.data || []).map((row: any) => ({
          reportDate: row.report_date,
          organization: row.submitting_org_name || '',
          workDescription: row.remarks || [row.location_name, row.layer_label].filter(Boolean).join(' · ') || 'Daily progress',
          progressPercentage: row.qty,
          qualityPassed: true,
          inspectionDone: !!row.pavement_work_item_id,
          photo: row.uom || '',
          raw: row,
        }));
        this.dataSource.data = rows;
      },
      error: () => {
        this.dataSource.data = [];
      },
    });
    this.plm.listMedia(q).subscribe({ next: (r: any) => (this.media = r.data || []) });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  submit(): void {
    this.plm
      .createDailyProgress({
        ...this.form,
        project_id: this.projectId,
        qty: this.form.qty || 0,
      })
      .subscribe({
        next: () => {
          this.toastr.success('Daily progress saved');
          this.form = { work_location_id: '', pavement_work_item_id: '', qty: '', remarks: '', weather: '' };
          this.reload();
        },
        error: (e) => this.toastr.error(e?.error?.message || 'Failed to save DPR'),
      });
  }

  addMedia(): void {
    this.plm
      .createMedia({
        ...this.mediaForm,
        project_id: this.projectId,
        content_type: 'image',
      })
      .subscribe({
        next: () => {
          this.toastr.success('Geotagged photo recorded');
          this.reload();
        },
        error: (e) => this.toastr.error(e?.error?.message || 'Failed'),
      });
  }
}
